module.exports = __webpack_public_path__ + "img/Rectangle73.2a94e675.png";